import Vue from 'vue';

//Buefy
import Buefy from 'buefy';
Vue.use(Buefy);

//moment
import moment from 'moment';
moment.locale(process.env.VUE_APP_LOCALE || 'es-do');

//VueFormWizard
import VueFormWizard from 'vue-form-wizard'
Vue.use(VueFormWizard)

//VeeValidate
import es from 'vee-validate/dist/locale/es'
import VeeValidate, { Validator } from 'vee-validate';
// Install the Plugin.
Vue.use(VeeValidate);
Validator.localize('es', es);

 //vue-mask
import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

